import React from 'react';

export function WrongCustomerNumberInfo() {

    return (
        <>
            <div style={{
                width: '100%',
                backgroundColor: '#3da2d9',
                padding: '20px',
                paddingLeft: '30px',
                marginBottom: '0px',
                color: 'white',
                marginTop: '20px',
                textAlign: 'left',
            }}>
                Ihre Kundennummer ist nicht gültig. Diese muss 8 Stellen haben und mit einer 2 beginnen.
                Sollte Ihre Kundenummer mit 1 oder 7 beginnen, nutzen Sie bitte dieses Formular:
                <a target="_blank" href="https://forms.ewe.de/kontaktformular-zaehlerstand-mitteilen">
                    <span style={{textDecoration: 'underline', color: 'white', marginLeft: '5px'}}>EWE Zählerstandsmitteilung</span>
                </a>
            </div>
        </>
    );

}